import printJS from "print-js";
import { findObjectUseCase } from "../../../usecases/object";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
export const printChart = (chartRefId) => {
  setTimeout(() => {
    printJS({
      printable: chartRefId,
      type: "html",
      header: `<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
                   <img src="/figaro.png" alt="Figaro" style="height: 50px;"/>
                   <h4 style="margin: 0 auto;">FIGARO COFFEE GROUP</h4>
                   <img src="/angels.png" alt="Angel's Pizza" style="height: 50px;"/>
                 </div>`,
      css: "./index.css",
      scanStyles: false,
      style: ".print-only-content { display: block; }",
    });
  }, 500);
};

export function formatSales(sales) {
  return sales.toLocaleString("en-US", {
    style: "currency",
    currency: "PHP",
  });
}

function convertToCSV(arrOfObjects, title) {
  if (!arrOfObjects || arrOfObjects.length === 0) {
    return "";
  }

  // 1) Title row + blank line
  let csv = title + "\n\n";

  // 2) Headers (use the keys of the first object)
  const headers = Object.keys(arrOfObjects[0]);
  csv += headers.join(",") + "\n";

  // 3) Each row
  arrOfObjects.forEach((obj) => {
    const row = headers.map((key) => {
      // Escape any double‐quotes in the value, and wrap in quotes if needed
      let val = obj[key] != null ? String(obj[key]) : "";
      if (val.includes(",") || val.includes('"')) {
        val = `"${val.replace(/"/g, '""')}"`;
      }
      return val;
    });
    csv += row.join(",") + "\n";
  });

  return csv;
}

function sumSales(source) {
  if (!source) return 0;

  // If it's an array of items: [{ sales, quantity, ...}, ...]
  if (Array.isArray(source)) {
    return source.reduce((sum, it) => sum + (Number(it?.sales) || 0), 0);
  }

  // If it's an object map: { "00001": { sales, quantity }, ... }
  return Object.values(source).reduce(
    (sum, it) => sum + (Number(it?.sales) || 0),
    0,
  );
}

function toNumber(v) {
  if (v == null) return 0;
  if (typeof v === "number" && Number.isFinite(v)) return v;
  // Strip commas, spaces, currency symbols, etc.
  const n = Number(String(v).replace(/[^0-9.-]/g, ""));
  return Number.isFinite(n) ? n : 0;
}

export async function exportToCSV(
  datasetType,
  isTop = true,
  numberOfItems = 3000,
  storess,
  range,
  itemDataRevenue,
  itemDataQuantity,
  itemDataQuantityFree,
) {
  if (!range || !range.tran_date) {
    console.error("exportToExcel: missing or invalid `range`");
    return;
  }

  // 1) Fetch the full master list
  const masterList = await findObjectUseCase().execute("products");

  const masterSkuSet = new Set(
    masterList.map((prod) => String(prod.sku).padStart(5, "0")),
  );

  console.log("itemDataRevenue:", itemDataRevenue);

  // 2) Normalize itemDataRevenue keys
  const normalizedRevenue = {};
  Object.keys(itemDataRevenue || {}).forEach((key) => {
    const normKey = String(key)
      .replace(/[^0-9]/g, "")
      .padStart(5, "0");
    normalizedRevenue[normKey] = itemDataRevenue[key];
  });

  console.log("normalized:", normalizedRevenue);

  // 3) Check missing SKUs and export if found
  await checkAndExportMissingSKUs(
    normalizedRevenue,
    masterSkuSet,
    itemDataRevenue,
  );

  // 4) Build mergedRows array
  const SKU_MULTIPLIERS = {
    "00775": 10,
    "00777": 10,
    "00779": 10,
    "00791": 3,
    "00792": 20,
  };

  const mergedRows = masterList.map((prod) => {
    const rawSku = String(prod.sku);
    const sku5 = rawSku.padStart(5, "0");
    const description = prod.description || prod.itemName;

    const revAgg = itemDataRevenue[sku5] || { sales: 0, quantity: 0 };
    const qtyAgg = itemDataQuantity[sku5] || { sales: 0, quantity: 0 };
    const revAggFree = itemDataQuantityFree[sku5] || { sales: 0, quantity: 0 };

    const multiplier = SKU_MULTIPLIERS[sku5] ?? 1;

    return {
      Store: storess,
      Date: `${range.tran_date["$gte"].split("T")[0]} - ${range.tran_date["$lte"].split("T")[0]}`,
      SKU: sku5,
      Item_Name: description,
      Unit_Price: toNumber(revAgg.unitPrice || 0),
      Revenue: toNumber(revAgg.sales),
      Sold_Quantity: (revAgg.quantity || 0) * multiplier,
      Free_Quantity: revAggFree.quantity,
      DineIn_Revenue: revAgg?.dineInRevenue || 0,
      DineIn_Sold: revAgg?.dineInSold || 0,
      TakeOut_Revenue: revAgg?.takeOutRevenue || 0,
      TakeOut_Sold: revAgg?.takeOutSold || 0,
      Delivery_Revenue: revAgg?.deliveryRevenue || 0,
      Delivery_Sold: revAgg?.deliverySold || 0,
      Grab_Revenue: revAgg?.grabRevenue || 0,
      Grab_Sold: revAgg?.grabSold || 0,
      DelTime_Revenue: revAgg?.delTimeRevenue || 0,
      DelTime_Sold: revAgg?.deltimeSold || 0,
      DriveThru_Revenue: revAgg?.driveThruRevenue || 0,
      DriveThru_Sold: revAgg?.driveThruSold || 0,
      FoodPanda_Revenue: revAgg?.foodPandaRevenue || 0,
      FoodPanda_Sold: revAgg?.foodPandaSold || 0,
      TableVibe_Revenue: revAgg?.tableVibeRevenue || 0,
      TableVibe_Sold: revAgg?.tableVibeSold || 0,
    };
  });

  // 5) Decide which slice to take
  let title;
  let fileNameSuffix;
  let sortedRows;

  if (datasetType === "revenue") {
    title = isTop ? "Top Item Revenue" : "Bottom Item Revenue";
    fileNameSuffix = isTop ? "top-item-revenue" : "bottom-item-revenue";

    sortedRows = mergedRows
      .sort((a, b) => (isTop ? b.Revenue - a.Revenue : a.Revenue - b.Revenue))
      .slice(0, numberOfItems);
  } else if (datasetType === "quantity") {
    title = isTop ? "Top Item Quantity" : "Bottom Item Quantity";
    fileNameSuffix = isTop ? "top-item-quantity" : "bottom-item-quantity";

    sortedRows = mergedRows
      .sort((a, b) =>
        isTop
          ? b.Sold_Quantity - a.Sold_Quantity
          : a.Sold_Quantity - b.Sold_Quantity,
      )
      .slice(0, numberOfItems);
  } else {
    console.error("exportToExcel: invalid datasetType:", datasetType);
    return;
  }

  // 6) Create Excel workbook with styling
  await createStyledExcelFile(
    sortedRows,
    title,
    storess,
    range,
    fileNameSuffix,
  );
}

/**
 * Create a styled Excel file using ExcelJS
 */
async function createStyledExcelFile(
  data,
  title,
  storeName,
  range,
  fileNameSuffix,
) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(title);

  // Define columns with proper formatting
  worksheet.columns = [
    { header: "Store", key: "Store", width: 12 },
    { header: "Date", key: "Date", width: 25 },
    { header: "SKU", key: "SKU", width: 10 },
    { header: "Item Name", key: "Item_Name", width: 40 },
    {
      header: "Unit Price",
      key: "Unit_Price",
      width: 12,
      style: { numFmt: "#,##0.00" },
    },
    {
      header: "Revenue",
      key: "Revenue",
      width: 15,
      style: { numFmt: "#,##0.00" },
    },
    {
      header: "Sold Qty",
      key: "Sold_Quantity",
      width: 12,
      style: { numFmt: "#,##0" },
    },
    {
      header: "Free Qty",
      key: "Free_Quantity",
      width: 12,
      style: { numFmt: "#,##0" },
    },
    { header: "", key: "spacer", width: 3 },
    {
      header: "Dine-In Revenue",
      key: "DineIn_Revenue",
      width: 15,
      style: { numFmt: "#,##0.00" },
    },
    {
      header: "Dine-In Sold",
      key: "DineIn_Sold",
      width: 12,
      style: { numFmt: "#,##0" },
    },
    {
      header: "Take-Out Revenue",
      key: "TakeOut_Revenue",
      width: 15,
      style: { numFmt: "#,##0.00" },
    },
    {
      header: "Take-Out Sold",
      key: "TakeOut_Sold",
      width: 12,
      style: { numFmt: "#,##0" },
    },
    {
      header: "Delivery Revenue",
      key: "Delivery_Revenue",
      width: 15,
      style: { numFmt: "#,##0.00" },
    },
    {
      header: "Delivery Sold",
      key: "Delivery_Sold",
      width: 12,
      style: { numFmt: "#,##0" },
    },
    {
      header: "Grab Revenue",
      key: "Grab_Revenue",
      width: 15,
      style: { numFmt: "#,##0.00" },
    },
    {
      header: "Grab Sold",
      key: "Grab_Sold",
      width: 12,
      style: { numFmt: "#,##0" },
    },
    {
      header: "DelTime Revenue",
      key: "DelTime_Revenue",
      width: 15,
      style: { numFmt: "#,##0.00" },
    },
    {
      header: "DelTime Sold",
      key: "DelTime_Sold",
      width: 12,
      style: { numFmt: "#,##0" },
    },
    {
      header: "Drive-Thru Revenue",
      key: "DriveThru_Revenue",
      width: 15,
      style: { numFmt: "#,##0.00" },
    },
    {
      header: "Drive-Thru Sold",
      key: "DriveThru_Sold",
      width: 12,
      style: { numFmt: "#,##0" },
    },
    {
      header: "FoodPanda Revenue",
      key: "FoodPanda_Revenue",
      width: 15,
      style: { numFmt: "#,##0.00" },
    },
    {
      header: "FoodPanda Sold",
      key: "FoodPanda_Sold",
      width: 12,
      style: { numFmt: "#,##0" },
    },
    {
      header: "TableVibe Revenue",
      key: "TableVibe_Revenue",
      width: 15,
      style: { numFmt: "#,##0.00" },
    },
    {
      header: "TableVibe Sold",
      key: "TableVibe_Sold",
      width: 12,
      style: { numFmt: "#,##0" },
    },
  ];

  // Add data rows
  data.forEach((row) => {
    worksheet.addRow(row);
  });

  // Style the header row
  const headerRow = worksheet.getRow(1);
  headerRow.height = 25;
  headerRow.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
  headerRow.alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true,
  };

  // Color coding for different sections
  headerRow.eachCell((cell, colNumber) => {
    if (colNumber <= 8) {
      // Main info columns (Store to Free Qty) - Dark Blue
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF2E5090" },
      };
    } else if (colNumber === 9) {
      // Spacer column - Light Gray
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE0E0E0" },
      };
    } else {
      // Channel-specific columns - Medium Blue
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF4472C4" },
      };
    }

    // Add borders to all header cells
    cell.border = {
      top: { style: "thin", color: { argb: "FF000000" } },
      left: { style: "thin", color: { argb: "FF000000" } },
      bottom: { style: "thin", color: { argb: "FF000000" } },
      right: { style: "thin", color: { argb: "FF000000" } },
    };
  });

  // Format data rows
  for (let i = 2; i <= worksheet.rowCount; i++) {
    const row = worksheet.getRow(i);
    row.height = 20;

    // Alternate row colors for better readability
    const fillColor = i % 2 === 0 ? "FFFFFFFF" : "FFF0F0F0";

    row.eachCell((cell, colNumber) => {
      // Apply number formatting based on column
      if (
        colNumber === 5 ||
        colNumber === 6 ||
        colNumber === 10 ||
        colNumber === 12 ||
        colNumber === 14 ||
        colNumber === 16 ||
        colNumber === 18 ||
        colNumber === 20 ||
        colNumber === 22 ||
        colNumber === 24
      ) {
        // Unit Price and Revenue columns
        cell.numFmt = "#,##0.00";
        cell.alignment = { horizontal: "right", vertical: "middle" };
      } else if (
        colNumber === 7 ||
        colNumber === 8 ||
        colNumber === 11 ||
        colNumber === 13 ||
        colNumber === 15 ||
        colNumber === 17 ||
        colNumber === 19 ||
        colNumber === 21 ||
        colNumber === 23 ||
        colNumber === 25
      ) {
        // Quantity columns
        cell.numFmt = "#,##0";
        cell.alignment = { horizontal: "right", vertical: "middle" };
      } else if (colNumber === 9) {
        // Spacer column
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE0E0E0" },
        };
      } else {
        // Text columns
        cell.alignment = { horizontal: "left", vertical: "middle" };
      }

      // Apply alternating row color
      if (colNumber !== 9) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: fillColor },
        };
      }

      // Add borders
      cell.border = {
        top: { style: "thin", color: { argb: "FFD0D0D0" } },
        left: { style: "thin", color: { argb: "FFD0D0D0" } },
        bottom: { style: "thin", color: { argb: "FFD0D0D0" } },
        right: { style: "thin", color: { argb: "FFD0D0D0" } },
      };
    });
  }

  // Add autofilter to header row
  worksheet.autoFilter = {
    from: { row: 1, column: 1 },
    to: { row: 1, column: 25 },
  };

  // Freeze the header row
  worksheet.views = [{ state: "frozen", xSplit: 0, ySplit: 1 }];

  // Add totals row at the bottom
  const totalRow = worksheet.addRow({
    Store: "",
    Date: "",
    SKU: "",
    Item_Name: "TOTAL",
    Unit_Price: "",
    Revenue: { formula: `SUM(F2:F${worksheet.rowCount - 1})` },
    Sold_Quantity: { formula: `SUM(G2:G${worksheet.rowCount - 1})` },
    Free_Quantity: { formula: `SUM(H2:H${worksheet.rowCount - 1})` },
    spacer: "",
    DineIn_Revenue: { formula: `SUM(J2:J${worksheet.rowCount - 1})` },
    DineIn_Sold: { formula: `SUM(K2:K${worksheet.rowCount - 1})` },
    TakeOut_Revenue: { formula: `SUM(L2:L${worksheet.rowCount - 1})` },
    TakeOut_Sold: { formula: `SUM(M2:M${worksheet.rowCount - 1})` },
    Delivery_Revenue: { formula: `SUM(N2:N${worksheet.rowCount - 1})` },
    Delivery_Sold: { formula: `SUM(O2:O${worksheet.rowCount - 1})` },
    Grab_Revenue: { formula: `SUM(P2:P${worksheet.rowCount - 1})` },
    Grab_Sold: { formula: `SUM(Q2:Q${worksheet.rowCount - 1})` },
    DelTime_Revenue: { formula: `SUM(R2:R${worksheet.rowCount - 1})` },
    DelTime_Sold: { formula: `SUM(S2:S${worksheet.rowCount - 1})` },
    DriveThru_Revenue: { formula: `SUM(T2:T${worksheet.rowCount - 1})` },
    DriveThru_Sold: { formula: `SUM(U2:U${worksheet.rowCount - 1})` },
    FoodPanda_Revenue: { formula: `SUM(V2:V${worksheet.rowCount - 1})` },
    FoodPanda_Sold: { formula: `SUM(W2:W${worksheet.rowCount - 1})` },
    TableVibe_Revenue: { formula: `SUM(X2:X${worksheet.rowCount - 1})` },
    TableVibe_Sold: { formula: `SUM(Y2:Y${worksheet.rowCount - 1})` },
  });

  // Style the totals row
  totalRow.font = { bold: true, size: 11 };
  totalRow.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFFFEB9C" }, // Light orange/yellow
  };
  totalRow.eachCell((cell, colNumber) => {
    if (
      colNumber === 5 ||
      colNumber === 6 ||
      colNumber === 10 ||
      colNumber === 12 ||
      colNumber === 14 ||
      colNumber === 16 ||
      colNumber === 18 ||
      colNumber === 20 ||
      colNumber === 22 ||
      colNumber === 24
    ) {
      cell.numFmt = "#,##0.00";
    } else if (
      colNumber === 7 ||
      colNumber === 8 ||
      colNumber === 11 ||
      colNumber === 13 ||
      colNumber === 15 ||
      colNumber === 17 ||
      colNumber === 19 ||
      colNumber === 21 ||
      colNumber === 23 ||
      colNumber === 25
    ) {
      cell.numFmt = "#,##0";
    }
    cell.border = {
      top: { style: "medium", color: { argb: "FF000000" } },
      left: { style: "thin", color: { argb: "FF000000" } },
      bottom: { style: "medium", color: { argb: "FF000000" } },
      right: { style: "thin", color: { argb: "FF000000" } },
    };
  });

  // Generate file and download
  const dateRange = `${range.tran_date["$gte"].split("T")[0]}-${range.tran_date["$lte"].split("T")[0]}`;
  const fileName = `${storeName}-${dateRange}-${fileNameSuffix}.xlsx`;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);

  console.log(`✅ Excel file exported: ${fileName}`);
}

/**
 * Check for missing SKUs and export them to a separate Excel file if found
 */
async function checkAndExportMissingSKUs(
  normalizedRevenue,
  masterSkuSet,
  itemDataRevenue,
) {
  const missingSkus = Object.keys(normalizedRevenue)
    .filter((sku5) => !masterSkuSet.has(sku5))
    .map((sku5) => ({
      SKU: sku5,
      Sales: normalizedRevenue[sku5]?.sales || 0,
      Quantity: normalizedRevenue[sku5]?.quantity || 0,
      Description: normalizedRevenue[sku5]?.description || "(no description)",
    }));

  if (missingSkus.length > 0) {
    console.warn(
      `⚠️ Found ${missingSkus.length} SKU(s) in itemDataRevenue not in angels_masterlist:`,
    );
    console.table(missingSkus);

    const totalMissingSales = missingSkus.reduce(
      (sum, item) => sum + Number(item.Sales || 0),
      0,
    );
    const totalMissingQty = missingSkus.reduce(
      (sum, item) => sum + Number(item.Quantity || 0),
      0,
    );

    console.warn(
      `🧾 TOTAL (missing SKUs): Sales = ${totalMissingSales.toLocaleString()} | Quantity = ${totalMissingQty}`,
    );

    // Create Excel file for missing SKUs
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Missing SKUs");

    worksheet.columns = [
      { header: "SKU", key: "SKU", width: 12 },
      { header: "Description", key: "Description", width: 40 },
      { header: "Sales", key: "Sales", width: 15 },
      { header: "Quantity", key: "Quantity", width: 12 },
    ];

    // Add data
    missingSkus.forEach((row) => worksheet.addRow(row));

    // Add totals row
    worksheet.addRow({
      SKU: "TOTAL",
      Description: "",
      Sales: totalMissingSales,
      Quantity: totalMissingQty,
    });

    // Style header
    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
    headerRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFDC3545" }, // Red for warning
    };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };

    // Style data rows
    for (let i = 2; i <= worksheet.rowCount; i++) {
      const row = worksheet.getRow(i);
      row.eachCell((cell, colNumber) => {
        if (colNumber === 3) {
          cell.numFmt = "#,##0.00";
        } else if (colNumber === 4) {
          cell.numFmt = "#,##0";
        }
        cell.alignment = {
          horizontal: colNumber <= 2 ? "left" : "right",
          vertical: "middle",
        };
      });
    }

    // Style totals row
    const totalRow = worksheet.getRow(worksheet.rowCount);
    totalRow.font = { bold: true };
    totalRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFEB9C" },
    };

    // Download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `missing-skus-${new Date().toISOString().split("T")[0]}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
  } else {
    console.log("✅ All SKUs in itemDataRevenue exist in masterlist.");
  }
}

// Helper function (assuming this exists in your codebase)
// function toNumber(value) {
//   const num = Number(value);
//   return isNaN(num) ? 0 : num;
// }
// export async function exportToCSV(
//   datasetType,
//   isTop = true,
//   numberOfItems = 3000,
//   storess,
//   range,
//   itemDataRevenue,
//   itemDataQuantity,
//   itemDataQuantityFree,
// ) {
//   if (!range || !range.tran_date) {
//     console.error("exportToCSV: missing or invalid `range`");
//     return;
//   }

//   // 1) Fetch the full master list
//   const masterList = await findObjectUseCase().execute("products");

//   const masterSkuSet = new Set(
//     masterList.map((prod) => String(prod.sku).padStart(5, "0")),
//   );

//   console.log("itemDataRevenue,", itemDataRevenue);

//   // 2) Normalize itemDataRevenue keys
//   const normalizedRevenue = {};
//   Object.keys(itemDataRevenue || {}).forEach((key) => {
//     const normKey = String(key)
//       .replace(/[^0-9]/g, "")
//       .padStart(5, "0");
//     normalizedRevenue[normKey] = itemDataRevenue[key];
//   });

//   console.log("normalize", normalizedRevenue);

//   // 3) Check missing SKUs
//   const missingSkus = Object.keys(normalizedRevenue)
//     .filter((sku5) => !masterSkuSet.has(sku5))
//     .map((sku5) => ({
//       SKU: sku5,
//       Sales: normalizedRevenue[sku5]?.sales || 0,
//       Quantity: normalizedRevenue[sku5]?.quantity || 0,
//       Description: normalizedRevenue[sku5]?.description || "(no description)",
//     }));

//   if (missingSkus.length > 0) {
//     console.warn(
//       `⚠️ Found ${missingSkus.length} SKU(s) in itemDataRevenue not in angels_masterlist:`,
//     );
//     console.table(missingSkus);
//     // 🧮 Compute totals
//     const totalMissingSales = missingSkus.reduce(
//       (sum, item) => sum + Number(item.Sales || 0),
//       0,
//     );
//     const totalMissingQty = missingSkus.reduce(
//       (sum, item) => sum + Number(item.Quantity || 0),
//       0,
//     );

//     console.warn(
//       `🧾 TOTAL (missing SKUs): Sales = ${totalMissingSales.toLocaleString()} | Quantity = ${totalMissingQty}`,
//     );

//     // 🧾 Build CSV with clear columns
//     const headers = ["SKU", "DESCRIPTION", "SALES", "QUANTITY"];
//     const csvRows = [
//       headers.join(","), // header row
//       ...missingSkus.map((item) =>
//         [
//           item.SKU,
//           `"${(item.Description || "").replace(/"/g, '""')}"`, // escape quotes safely
//           item.Sales,
//           item.Quantity,
//         ].join(","),
//       ),
//       ["TOTAL", "", totalMissingSales, totalMissingQty].join(","),
//     ];

//     const csvContent = csvRows.join("\n");

//     // 💾 Create blob and download CSV
//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `missing-skus-${new Date().toISOString().split("T")[0]}.csv`;
//     a.click();
//     URL.revokeObjectURL(url);
//   } else {
//     console.log("✅ All SKUs in itemDataRevenue exist in masterlist.");
//   }

//   // 2) Build mergedRows array
//   const mergedRows = masterList.map((prod) => {
//     const rawSku = String(prod.sku);
//     const sku5 = rawSku.padStart(5, "0");
//     const description = prod.description || "";

//     // Use 0 if missing
//     const totalRevenueSales = sumSales(itemDataRevenue);
//     const revAgg = itemDataRevenue[sku5] || { sales: 0, quantity: 0 };
//     const qtyAgg = itemDataQuantity[sku5] || { sales: 0, quantity: 0 };
//     const revAggFree = itemDataQuantityFree[sku5] || { sales: 0, quantity: 0 };

//     return {
//       Store: storess,
//       Date: `${range.tran_date["$gte"].split("T")[0]} - ${
//         range.tran_date["$lte"].split("T")[0]
//       }`,
//       SKU: sku5,
//       Item_Name: description,
//       // For revenue‐based CSV rows, use revAgg; for quantity‐based, use qtyAgg
//       // Revenue: Number(revAgg.sales),
//       Revenue: toNumber(revAgg.sales),
//       Sold_Quantity: revAgg.quantity,
//       Free_Quanity: revAggFree.quantity,
//       " ": " ",
//       DineIn_Revenue: revAgg?.dineInRevenue,
//       DineIn_Sold: revAgg?.dineInSold,
//       TakeOut_Revenue: revAgg?.takeOutRevenue,
//       TakeOut_Sold: revAgg?.takeOutSold,
//       Delivery_Revenue: revAgg?.deliveryRevenue,
//       Delivery_Sold: revAgg?.deliverySold,
//       Grab_Revenue: revAgg?.grabRevenue,
//       Grab_Sold: revAgg?.grabSold,
//       DelTime_Revenue: revAgg?.delTimeRevenue,
//       DelTime_Sold: revAgg?.deltimeSold,
//       DriveThru_Revenue: revAgg?.driveThruRevenue,
//       DriveThru_Sold: revAgg?.driveThruSold,
//       FoodPanda_Revenue: revAgg?.foodPandaRevenue,
//       FoodPanda_Sold: revAgg?.foodPandaSold,
//       TableVibe_Revenue: revAgg?.tableVibeRevenue,
//       TableVibe_Sold: revAgg?.tableVibeSold,
//     };
//   });

//   // 3) Decide which slice to take
//   let title;
//   let fileNameSuffix;
//   let sortedRows;

//   if (datasetType === "revenue") {
//     title = isTop ? "Top Item Revenue" : "Bottom Item Revenue";
//     fileNameSuffix = isTop ? "top-item-revenue" : "bottom-item-revenue";

//     sortedRows = mergedRows
//       .sort((a, b) => (isTop ? b.Revenue - a.Revenue : a.Revenue - b.Revenue))
//       .slice(0, numberOfItems);
//   } else if (datasetType === "quantity") {
//     title = isTop ? "Top Item Quantity" : "Bottom Item Quantity";
//     fileNameSuffix = isTop ? "top-item-quantity" : "bottom-item-quantity";

//     sortedRows = mergedRows
//       .sort((a, b) =>
//         isTop ? b.Quantity - a.Quantity : a.Quantity - b.Quantity,
//       )
//       .slice(0, numberOfItems);
//   } else {
//     console.error("exportToCSV: invalid datasetType:", datasetType);
//     return;
//   }

//   // 4) Convert to CSV string
//   const csvString = convertToCSV(sortedRows, title);
//   if (!csvString) {
//     console.error("exportToCSV: nothing to download (empty CSV).");
//     return;
//   }

//   // 5) Trigger browser download
//   const blob = new Blob([csvString], { type: "text/csv" });
//   const url = window.URL.createObjectURL(blob);
//   const a = document.createElement("a");

//   const dateRange = `${range.tran_date["$gte"].split("T")[0]}-${
//     range.tran_date["$lte"].split("T")[0]
//   }`;
//   a.href = url;
//   a.download = `${storess}-${dateRange}-${fileNameSuffix}.csv`;
//   a.click();
//   window.URL.revokeObjectURL(url);
// }

export async function exportToCSVSearch(
  datasetType,
  isTop = true,
  numberOfItems = 3000,
  storess,
  store,
  range,
  itemDataRevenue,
  itemDataQuantity,
  itemDataQuantityFree,
) {
  console.log("range", range, "Store", store, "Storesss", storess);
  if (!range || !range?.tran_date) {
    console.error("exportToCSV: missing or invalid `range`");
    return;
  }

  // Load search keyword
  let keyword = "";
  try {
    keyword = (localStorage.getItem("lastSearchKeyword") || "").trim();
  } catch (e) {
    console.warn("exportToCSV: unable to read lastSearchKeyword", e);
  }
  const hasKeyword = keyword !== "";
  const lowerKeyword = keyword.toLowerCase();

  // Fetch master list
  const masterList = await findObjectUseCase().execute("products");
  const masterSkuSet = new Set(
    masterList.map((prod) => String(prod.sku).padStart(5, "0")),
  );

  console.log("itemDataRevenue,", itemDataRevenue);

  // Normalize itemDataRevenue keys
  const normalizedRevenue = {};
  Object.keys(itemDataRevenue || {}).forEach((key) => {
    const normKey = String(key)
      .replace(/[^0-9]/g, "")
      .padStart(5, "0");
    normalizedRevenue[normKey] = itemDataRevenue[key];
  });

  console.log("normalize", normalizedRevenue);

  // Check missing SKUs and export if any
  await exportMissingSKUs(normalizedRevenue, masterSkuSet);

  // Filter masterList by keyword
  const filteredMasterList = masterList.filter((prod) => {
    if (!hasKeyword) return true;
    const desc = (prod.description || "").toLowerCase();
    return desc.includes(lowerKeyword);
  });

  // Build title and filename
  let title;
  let fileNameSuffix;
  if (datasetType === "revenue") {
    title = isTop ? "Top Item Revenue" : "Bottom Item Revenue";
    fileNameSuffix = isTop ? "top-item-revenue" : "bottom-item-revenue";
  } else if (datasetType === "quantity") {
    title = isTop ? "Top Item Quantity" : "Bottom Item Quantity";
    fileNameSuffix = isTop ? "top-item-quantity" : "bottom-item-quantity";
  } else {
    console.error("exportToCSV: invalid datasetType:", datasetType);
    return;
  }

  if (hasKeyword) {
    title += ` (filtered by "${keyword}")`;
    fileNameSuffix += `-${keyword.replace(/[^a-z0-9]+/gi, "_")}`;
  }

  // Build XLSX with store sections and styling
  await exportToXLSXWithStyling(
    filteredMasterList,
    itemDataRevenue,
    itemDataQuantity,
    itemDataQuantityFree,
    range,
    datasetType,
    isTop,
    numberOfItems,
    title,
    storess,
    fileNameSuffix,
  );
}

// Helper: Export missing SKUs
async function exportMissingSKUs(normalizedRevenue, masterSkuSet) {
  const missingSkus = Object.keys(normalizedRevenue)
    .filter((sku5) => !masterSkuSet.has(sku5))
    .map((sku5) => ({
      SKU: sku5,
      Sales: normalizedRevenue[sku5]?.sales || 0,
      Quantity: normalizedRevenue[sku5]?.quantity || 0,
      Description: normalizedRevenue[sku5]?.description || "(no description)",
    }));

  if (missingSkus.length === 0) {
    console.log("✅ All SKUs in itemDataRevenue exist in masterlist.");
    return;
  }

  console.warn(
    `⚠️ Found ${missingSkus.length} SKU(s) in itemDataRevenue not in angels_masterlist:`,
  );
  console.table(missingSkus);

  const totalMissingSales = missingSkus.reduce(
    (sum, item) => sum + Number(item.Sales || 0),
    0,
  );
  const totalMissingQty = missingSkus.reduce(
    (sum, item) => sum + Number(item.Quantity || 0),
    0,
  );

  console.warn(
    `🧾 TOTAL (missing SKUs): Sales = ${totalMissingSales.toLocaleString()} | Quantity = ${totalMissingQty}`,
  );

  const headers = ["SKU", "DESCRIPTION", "SALES", "QUANTITY"];
  const csvRows = [
    headers.join(","),
    ...missingSkus.map((item) =>
      [
        item.SKU,
        `"${(item.Description || "").replace(/"/g, '""')}"`,
        item.Sales,
        item.Quantity,
      ].join(","),
    ),
    ["TOTAL", "", totalMissingSales, totalMissingQty].join(","),
  ];

  const csvContent = csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `missing-skus-${new Date().toISOString().split("T")[0]}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

// Helper: Export to XLSX with styling using ExcelJS
async function exportToXLSXWithStyling(
  filteredMasterList,
  itemDataRevenue,
  itemDataQuantity,
  itemDataQuantityFree,
  range,
  datasetType,
  isTop,
  numberOfItems,
  title,
  storess,
  fileNameSuffix,
) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Report");

  // Collect all unique stores
  const storesSet = new Set();
  filteredMasterList.forEach((prod) => {
    const sku5 = String(prod.sku).padStart(5, "0");
    const revAgg = itemDataRevenue?.[sku5];
    if (revAgg?.stores) {
      Object.keys(revAgg.stores).forEach((storeCode) => {
        storesSet.add(storeCode);
      });
    }
  });

  const allStores = Array.from(storesSet).sort();
  const dateRange = `${range.tran_date["$gte"].split("T")[0]} - ${range.tran_date["$lte"].split("T")[0]}`;

  let currentRow = 1;

  // Process each store
  allStores.forEach((storeCode, storeIndex) => {
    const storeRows = buildStoreRows(
      filteredMasterList,
      itemDataRevenue,
      itemDataQuantity,
      itemDataQuantityFree,
      storeCode,
      dateRange,
    );

    const sortedRows = sortRows(storeRows, datasetType, isTop, numberOfItems);
    if (sortedRows.length === 0) return;

    // Add spacing between stores
    if (storeIndex > 0) {
      currentRow += 2;
    }

    // // Section title
    // const sectionTitle = `${title} - ${storeCode}`;
    // const titleRow = worksheet.getRow(currentRow);
    // titleRow.getCell(1).value = sectionTitle;
    // titleRow.getCell(1).font = {
    //   bold: true,
    //   size: 14,
    //   color: { argb: "FFFFFFFF" },
    // };
    // titleRow.getCell(1).fill = {
    //   type: "pattern",
    //   pattern: "solid",
    //   fgColor: { argb: "FF4472C4" },
    // };
    // titleRow.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
    // titleRow.height = 25;
    // worksheet.mergeCells(currentRow, 1, currentRow, 24);
    // currentRow += 2;
    // Section title
    const sectionTitle = `${title} - ${storeCode}`;
    const titleRow = worksheet.getRow(currentRow);
    titleRow.getCell(1).value = sectionTitle;
    titleRow.getCell(1).font = {
      bold: true,
      size: 14,
      color: { argb: "FF000000" },
    }; // Black text
    titleRow.getCell(1).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFFFFF" }, // White background
    };
    titleRow.getCell(1).alignment = { vertical: "middle", horizontal: "left" };
    titleRow.height = 25;
    worksheet.mergeCells(currentRow, 1, currentRow, 25);
    currentRow += 2;

    // Headers
    const headerRow = worksheet.getRow(currentRow);
    const headers = [
      "Store",
      "Date",
      "SKU",
      "Item_Name",
      "Unit_Price",
      "Revenue",
      "Sold_Quantity",
      "Free_Quantity",
      "",
      "DineIn_Revenue",
      "DineIn_Sold",
      "TakeOut_Revenue",
      "TakeOut_Sold",
      "Delivery_Revenue",
      "Delivery_Sold",
      "Grab_Revenue",
      "Grab_Sold",
      "DelTime_Revenue",
      "DelTime_Sold",
      "DriveThru_Revenue",
      "DriveThru_Sold",
      "FoodPanda_Revenue",
      "FoodPanda_Sold",
      "TableVibe_Revenue",
      "TableVibe_Sold",
    ];

    headers.forEach((header, index) => {
      const cell = headerRow.getCell(index + 1);
      cell.value = header;
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF5B9BD5" },
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
    headerRow.height = 20;
    currentRow++;

    // Data rows
    sortedRows.forEach((rowData, rowIndex) => {
      const dataRow = worksheet.getRow(currentRow);
      const isEvenRow = rowIndex % 2 === 0;
      const bgColor = isEvenRow ? "FFFFFFFF" : "FFF2F2F2";

      const values = [
        rowData.Store,
        rowData.Date,
        rowData.SKU,
        rowData.Item_Name,
        rowData.Unit_Price || 0,
        rowData.Revenue || 0,
        rowData.Sold_Quantity || 0,
        rowData.Free_Quantity || 0,
        "",
        rowData.DineIn_Revenue || 0,
        rowData.DineIn_Sold || 0,
        rowData.TakeOut_Revenue || 0,
        rowData.TakeOut_Sold || 0,
        rowData.Delivery_Revenue || 0,
        rowData.Delivery_Sold || 0,
        rowData.Grab_Revenue || 0,
        rowData.Grab_Sold || 0,
        rowData.DelTime_Revenue || 0,
        rowData.DelTime_Sold || 0,
        rowData.DriveThru_Revenue || 0,
        rowData.DriveThru_Sold || 0,
        rowData.FoodPanda_Revenue || 0,
        rowData.FoodPanda_Sold || 0,
        rowData.TableVibe_Revenue || 0,
        rowData.TableVibe_Sold || 0,
      ];

      values.forEach((value, colIndex) => {
        const cell = dataRow.getCell(colIndex + 1);
        cell.value = value;
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: bgColor },
        };
        cell.alignment = {
          vertical: "middle",
          horizontal: colIndex === 3 ? "left" : "right",
        };
        cell.border = {
          top: { style: "thin", color: { argb: "FFD3D3D3" } },
          left: { style: "thin", color: { argb: "FFD3D3D3" } },
          bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
          right: { style: "thin", color: { argb: "FFD3D3D3" } },
        };

        // Number formatting
        if (colIndex === 4 || colIndex === 5) {
          cell.numFmt = "#,##0.00";
        } else if (colIndex >= 6 && colIndex !== 8) {
          cell.numFmt = "#,##0";
        }
      });

      currentRow++;
    });

    // Totals row
    const totals = calculateStoreTotals(sortedRows);
    currentRow++; // Empty row

    const totalRow = worksheet.getRow(currentRow);
    const totalValues = [
      "TOTAL",
      "",
      "",
      "",
      "",
      totals.revenue,
      totals.quantity,
      totals.freeQuantity,
      "",
      totals.dineInRevenue,
      totals.dineInSold,
      totals.takeOutRevenue,
      totals.takeOutSold,
      totals.deliveryRevenue,
      totals.deliverySold,
      totals.grabRevenue,
      totals.grabSold,
      totals.delTimeRevenue,
      totals.delTimeSold,
      totals.driveThruRevenue,
      totals.driveThruSold,
      totals.foodPandaRevenue,
      totals.foodPandaSold,
      totals.tableVibeRevenue,
      totals.tableVibeSold,
    ];

    totalValues.forEach((value, colIndex) => {
      const cell = totalRow.getCell(colIndex + 1);
      cell.value = value;
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF70AD47" },
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: colIndex === 0 ? "left" : "right",
      };
      cell.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };

      // Number formatting for totals
      if (colIndex === 5) {
        cell.numFmt = "#,##0.00";
      } else if (colIndex >= 6 && colIndex !== 8) {
        cell.numFmt = "#,##0";
      }
    });
    totalRow.height = 20;
    currentRow++;
  });

  // Set column widths
  worksheet.columns = [
    { width: 30 }, // Store
    { width: 25 }, // Date
    { width: 10 }, // SKU
    { width: 40 }, // Item_Name
    { width: 12 }, // Unit_Price
    { width: 12 }, // Revenue
    { width: 15 }, // Sold_Quantity
    { width: 15 }, // Free_Quantity
    { width: 3 }, // Separator
    { width: 15 }, // DineIn_Revenue
    { width: 12 }, // DineIn_Sold
    { width: 15 }, // TakeOut_Revenue
    { width: 13 }, // TakeOut_Sold
    { width: 16 }, // Delivery_Revenue
    { width: 13 }, // Delivery_Sold
    { width: 13 }, // Grab_Revenue
    { width: 11 }, // Grab_Sold
    { width: 15 }, // DelTime_Revenue
    { width: 13 }, // DelTime_Sold
    { width: 16 }, // DriveThru_Revenue
    { width: 14 }, // DriveThru_Sold
    { width: 17 }, // FoodPanda_Revenue
    { width: 15 }, // FoodPanda_Sold
    { width: 17 }, // TableVibe_Revenue
    { width: 15 }, // TableVibe_Sold
  ];

  // Write and download
  const dateRangeFilename = `${range.tran_date["$gte"].split("T")[0]}-${
    range.tran_date["$lte"].split("T")[0]
  }`;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${storess}-${dateRangeFilename}-${fileNameSuffix}.xlsx`;
  a.click();
  window.URL.revokeObjectURL(url);
}

// Helper: Build rows for a specific store
const SKU_MULTIPLIERS_SEARCH = {
  "00775": 10,
  "00777": 10,
  "00779": 10,
  "00791": 3,
  "00792": 20,
};

function buildStoreRows(
  filteredMasterList,
  itemDataRevenue,
  itemDataQuantity,
  itemDataQuantityFree,
  storeCode,
  dateRange,
) {
  return filteredMasterList
    .map((prod) => {
      const sku5 = String(prod.sku).padStart(5, "0");
      const revAgg = itemDataRevenue?.[sku5];
      const qtyAgg = itemDataQuantity?.[sku5];
      const revAggFree = itemDataQuantityFree?.[sku5];

      const storeData = revAgg?.stores?.[storeCode];
      if (!storeData) return null;

      const multiplier = SKU_MULTIPLIERS_SEARCH[sku5] ?? 1;

      return {
        Store: storeCode,
        Date: dateRange,
        SKU: sku5,
        Item_Name: prod.description || "",
        Unit_Price: toNumberr(revAgg?.unitPrice || 0),
        Revenue: toNumberr(storeData.sales || 0),
        Sold_Quantity: (storeData.quantity || 0) * multiplier,
        Free_Quantity: revAggFree?.quantity || 0,
        DineIn_Revenue: storeData.dineInRevenue || 0,
        DineIn_Sold: storeData.dineInSold || 0,
        TakeOut_Revenue: storeData.takeOutRevenue || 0,
        TakeOut_Sold: storeData.takeOutSold || 0,
        Delivery_Revenue: storeData.deliveryRevenue || 0,
        Delivery_Sold: storeData.deliverySold || 0,
        Grab_Revenue: storeData.grabRevenue || 0,
        Grab_Sold: storeData.grabSold || 0,
        DelTime_Revenue: storeData.delTimeRevenue || 0,
        DelTime_Sold: storeData.deltimeSold || 0,
        DriveThru_Revenue: storeData.driveThruRevenue || 0,
        DriveThru_Sold: storeData.driveThruSold || 0,
        FoodPanda_Revenue: storeData.foodPandaRevenue || 0,
        FoodPanda_Sold: storeData.foodPandaSold || 0,
        TableVibe_Revenue: storeData.tableVibeRevenue || 0,
        TableVibe_Sold: storeData.tableVibeSold || 0,
      };
    })
    .filter(Boolean);
}

// Helper: Sort rows
function sortRows(rows, datasetType, isTop, numberOfItems) {
  let sorted;

  if (datasetType === "revenue") {
    sorted = rows.sort((a, b) =>
      isTop ? b.Revenue - a.Revenue : a.Revenue - b.Revenue,
    );
  } else if (datasetType === "quantity") {
    sorted = rows.sort((a, b) =>
      isTop
        ? (b.Sold_Quantity || 0) - (a.Sold_Quantity || 0)
        : (a.Sold_Quantity || 0) - (b.Sold_Quantity || 0),
    );
  } else {
    return rows;
  }

  return sorted.slice(0, numberOfItems);
}

// Helper: Calculate totals
function calculateStoreTotals(rows) {
  return rows.reduce(
    (totals, row) => {
      return {
        revenue: totals.revenue + (row.Revenue || 0),
        quantity: totals.quantity + (row.Sold_Quantity || 0),
        freeQuantity: totals.freeQuantity + (row.Free_Quantity || 0),
        dineInRevenue: totals.dineInRevenue + (row.DineIn_Revenue || 0),
        dineInSold: totals.dineInSold + (row.DineIn_Sold || 0),
        takeOutRevenue: totals.takeOutRevenue + (row.TakeOut_Revenue || 0),
        takeOutSold: totals.takeOutSold + (row.TakeOut_Sold || 0),
        deliveryRevenue: totals.deliveryRevenue + (row.Delivery_Revenue || 0),
        deliverySold: totals.deliverySold + (row.Delivery_Sold || 0),
        grabRevenue: totals.grabRevenue + (row.Grab_Revenue || 0),
        grabSold: totals.grabSold + (row.Grab_Sold || 0),
        delTimeRevenue: totals.delTimeRevenue + (row.DelTime_Revenue || 0),
        delTimeSold: totals.delTimeSold + (row.DelTime_Sold || 0),
        driveThruRevenue:
          totals.driveThruRevenue + (row.DriveThru_Revenue || 0),
        driveThruSold: totals.driveThruSold + (row.DriveThru_Sold || 0),
        foodPandaRevenue:
          totals.foodPandaRevenue + (row.FoodPanda_Revenue || 0),
        foodPandaSold: totals.foodPandaSold + (row.FoodPanda_Sold || 0),
        tableVibeRevenue:
          totals.tableVibeRevenue + (row.TableVibe_Revenue || 0),
        tableVibeSold: totals.tableVibeSold + (row.TableVibe_Sold || 0),
      };
    },
    {
      revenue: 0,
      quantity: 0,
      freeQuantity: 0,
      dineInRevenue: 0,
      dineInSold: 0,
      takeOutRevenue: 0,
      takeOutSold: 0,
      deliveryRevenue: 0,
      deliverySold: 0,
      grabRevenue: 0,
      grabSold: 0,
      delTimeRevenue: 0,
      delTimeSold: 0,
      driveThruRevenue: 0,
      driveThruSold: 0,
      foodPandaRevenue: 0,
      foodPandaSold: 0,
      tableVibeRevenue: 0,
      tableVibeSold: 0,
    },
  );
}

// Helper: Convert to number
function toNumberr(value) {
  const num = parseFloat(value);
  return isNaN(num) ? 0 : num;
}

export function getChartDataTopRevenueSearch(itemDataRevenue) {
  // 0) Get last search keyword from localStorage
  let keyword = "";
  try {
    keyword = (localStorage.getItem("lastSearchKeyword") || "").trim();
  } catch (e) {
    console.warn("Unable to read lastSearchKeyword from localStorage", e);
  }

  const hasKeyword = keyword !== "";
  const lowerKeyword = keyword.toLowerCase();

  // 1) Convert object to entries and (optionally) filter by keyword
  const filteredEntries = Object.entries(itemDataRevenue).filter(([, item]) => {
    if (!hasKeyword) return true; // no keyword -> include all

    const desc = (item.description || "").toLowerCase();
    return desc.includes(lowerKeyword);
  });

  console.log("filteredEntries", filteredEntries);

  // 2) Sort items by descending sales, then take top 30
  const sortedItems = filteredEntries
    .sort((a, b) => b[1].sales - a[1].sales)
    .slice(0, 30);

  // 3) Extract labels (descriptions) and numeric sales data
  const labels = sortedItems.map(([, item]) => item.description);
  const salesData = sortedItems.map(([, item]) =>
    parseFloat(item.sales.toFixed(2)),
  );

  console.log("ANG BENTA", labels, salesData);

  // 4) Return the Highcharts configuration object
  return {
    chart: {
      type: "bar", // horizontal bar
    },
    title: {
      text: hasKeyword
        ? `Top Menu Items by Revenue (filtered by "${keyword}")`
        : "Top 30 Menu Items by Revenue",
    },
    xAxis: {
      categories: labels,
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: "10px", // para hindi masyadong malaki pag mahaba ang text
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Total Sales (PHP)",
        align: "high",
      },
      labels: {
        overflow: "justify",
      },
    },
    tooltip: {
      valuePrefix: "₱",
      valueDecimals: 2,
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          format: "₱{point.y:.2f}",
        },
      },
    },
    series: [
      {
        name: "Total Sales",
        data: salesData,
        color: "#006096",
      },
    ],
  };
}

export function getChartDataTopRevenue(itemDataRevenue) {
  // 1) Sort items by descending sales, then take top 30
  const sortedItems = Object.entries(itemDataRevenue)
    .sort((a, b) => b[1].sales - a[1].sales)
    .slice(0, 30);

  // 2) Extract labels (descriptions) and numeric sales data
  const labels = sortedItems.map(([, item]) => item.description);
  const salesData = sortedItems.map(([, item]) =>
    parseFloat(item.sales.toFixed(2)),
  );

  // 3) Return the Highcharts configuration object
  return {
    chart: {
      type: "bar", // horizontal bar
    },
    title: {
      text: "Top 30 Menu Items by Revenue",
    },
    xAxis: {
      categories: labels,
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: "10px", // agar hindi masyadong malaki pag mahaba ang text
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Total Sales (PHP)",
        align: "high",
      },
      labels: {
        overflow: "justify",
      },
    },
    tooltip: {
      valuePrefix: "₱",
      valueDecimals: 2,
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          format: "₱{point.y:.2f}",
        },
      },
    },
    series: [
      {
        name: "Total Sales",
        data: salesData,
        color: "#006096",
      },
    ],
  };
}

export function getChartDataBottomRevenueSearch(itemDataRevenue) {
  // 0) Get last search keyword from localStorage
  let keyword = "";
  try {
    keyword = (localStorage.getItem("lastSearchKeyword") || "").trim();
  } catch (e) {
    console.warn("Unable to read lastSearchKeyword from localStorage", e);
  }

  const hasKeyword = keyword !== "";
  const lowerKeyword = keyword.toLowerCase();

  // 1) Convert to entries and optionally filter by keyword
  const filteredEntries = Object.entries(itemDataRevenue || {}).filter(
    ([, item]) => {
      if (!hasKeyword) return true; // no search keyword = include all

      const desc = (item.description || "").toLowerCase();
      return desc.includes(lowerKeyword);
    },
  );

  // 2) Sort by ascending revenue (bottom)
  const sortedItems = filteredEntries
    .sort((a, b) => a[1].sales - b[1].sales)
    .slice(0, 30);

  // 3) Extract labels and values
  const labels = sortedItems.map(([, item]) => item.description);
  const salesData = sortedItems.map(([, item]) =>
    parseFloat(item.sales.toFixed(2)),
  );

  // 4) Build chart config
  return {
    chart: { type: "bar" },
    title: {
      text: hasKeyword
        ? `Bottom Items by Revenue (filtered by "${keyword}")`
        : "Bottom 30 Items by Revenue",
    },
    xAxis: {
      categories: labels,
      title: { text: null },
      labels: { style: { fontSize: "10px" } },
    },
    yAxis: {
      min: 0,
      title: { text: "Total Sales (PHP)", align: "high" },
      labels: { overflow: "justify" },
    },
    tooltip: { valuePrefix: "₱", valueDecimals: 2 },
    plotOptions: {
      bar: {
        dataLabels: { enabled: true, format: "₱{point.y:.2f}" },
      },
    },
    series: [
      {
        name: "Total Sales",
        data: salesData,
        color: "#006096",
      },
    ],
  };
}

export function getChartDataBottomRevenue(itemDataRevenue) {
  const sortedItems = Object.entries(itemDataRevenue || {})
    .sort((a, b) => a[1].sales - b[1].sales)
    .slice(0, 30);

  const labels = sortedItems.map(([, item]) => item.description);
  const salesData = sortedItems.map(([, item]) =>
    parseFloat(item.sales.toFixed(2)),
  );

  return {
    chart: { type: "bar" },
    title: { text: "Bottom 30 Items by Revenue" },
    xAxis: {
      categories: labels,
      title: { text: null },
      labels: { style: { fontSize: "10px" } },
    },
    yAxis: {
      min: 0,
      title: { text: "Total Sales (PHP)", align: "high" },
      labels: { overflow: "justify" },
    },
    tooltip: { valuePrefix: "₱", valueDecimals: 2 },
    plotOptions: {
      bar: {
        dataLabels: { enabled: true, format: "₱{point.y:.2f}" },
      },
    },
    series: [
      {
        name: "Total Sales",
        data: salesData,
        color: "#006096",
      },
    ],
  };
}

export function getChartDataTopQuantitySearch(itemDataQuantity) {
  // 0) Load search keyword from localStorage
  let keyword = "";
  try {
    keyword = (localStorage.getItem("lastSearchKeyword") || "").trim();
  } catch (e) {
    console.warn("Unable to read lastSearchKeyword", e);
  }

  const hasKeyword = keyword !== "";
  const lowerKeyword = keyword.toLowerCase();

  // 1) Filter items based on keyword
  const filteredEntries = Object.entries(itemDataQuantity || {}).filter(
    ([, item]) => {
      if (!hasKeyword) return true;
      const desc = (item.description || "").toLowerCase();
      return desc.includes(lowerKeyword);
    },
  );

  // 2) Sort descending by quantity, take top 30
  const sortedItems = filteredEntries
    .sort((a, b) => b[1].quantity - a[1].quantity)
    .slice(0, 30);

  // 3) Extract labels and values
  const labels = sortedItems.map(([, item]) => item.description);
  const quantityData = sortedItems.map(([, item]) => parseFloat(item.quantity));

  // 4) Return config
  return {
    chart: { type: "bar" },
    title: {
      text: hasKeyword
        ? `Top Items by Quantity (filtered by "${keyword}")`
        : "Top 30 Items by Quantity",
    },
    xAxis: {
      categories: labels,
      labels: { style: { fontSize: "10px" } },
    },
    yAxis: {
      min: 0,
      title: { text: "Total Quantity", align: "high" },
    },
    tooltip: { valueSuffix: " pcs" },
    plotOptions: {
      bar: {
        dataLabels: { enabled: true, format: "{point.y} pcs" },
      },
    },
    series: [
      {
        name: "Total Quantity",
        data: quantityData,
        color: "#006096",
      },
    ],
  };
}

export function getChartDataTopQuantity(itemDataQuantity) {
  // 1) Sort items descending by quantity, take top 30
  const sortedItems = Object.entries(itemDataQuantity || {})
    .sort((a, b) => b[1].quantity - a[1].quantity)
    .slice(0, 30);

  // 2) Extract labels (descriptions) and numeric quantities
  const labels = sortedItems.map(([, item]) => item.description);
  const quantityData = sortedItems.map(([, item]) => parseFloat(item.quantity));

  // 3) Build and return Highcharts options
  return {
    chart: {
      type: "bar", // horizontal bar
    },
    title: {
      text: "Top 30 Items by Quantity",
    },
    xAxis: {
      categories: labels,
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: "10px",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Total Quantity",
        align: "high",
      },
      labels: {
        overflow: "justify",
      },
    },
    tooltip: {
      valueSuffix: " pcs",
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          format: "{point.y} pcs",
        },
      },
    },
    series: [
      {
        name: "Total Quantity",
        data: quantityData,
        color: "#006096",
      },
    ],
  };
}

export function getChartDataBottomQuantitySearch(itemDataQuantity) {
  // 0) Load search keyword
  let keyword = "";
  try {
    keyword = (localStorage.getItem("lastSearchKeyword") || "").trim();
  } catch (e) {
    console.warn("Unable to read lastSearchKeyword", e);
  }

  const hasKeyword = keyword !== "";
  const lowerKeyword = keyword.toLowerCase();

  // 1) Filter items using keyword
  const filteredEntries = Object.entries(itemDataQuantity || {}).filter(
    ([, item]) => {
      if (!hasKeyword) return true;
      const desc = (item.description || "").toLowerCase();
      return desc.includes(lowerKeyword);
    },
  );

  // 2) Sort ascending by quantity, take bottom 30
  const sortedItems = filteredEntries
    .sort((a, b) => a[1].quantity - b[1].quantity)
    .slice(0, 30);

  // 3) Extract labels and values
  const labels = sortedItems.map(([, item]) => item.description);
  const quantityData = sortedItems.map(([, item]) => parseFloat(item.quantity));

  // 4) Return chart config
  return {
    chart: { type: "bar" },
    title: {
      text: hasKeyword
        ? `Bottom Items by Quantity (filtered by "${keyword}")`
        : "Bottom 30 Items by Quantity",
    },
    xAxis: {
      categories: labels,
      labels: { style: { fontSize: "10px" } },
    },
    yAxis: {
      min: 0,
      title: { text: "Total Quantity", align: "high" },
    },
    tooltip: { valueSuffix: " pcs" },
    plotOptions: {
      bar: {
        dataLabels: { enabled: true, format: "{point.y} pcs" },
      },
    },
    series: [
      {
        name: "Quantity",
        data: quantityData,
        color: "#006096",
      },
    ],
  };
}

// Pivot Report: rows = stores, columns = products (Sold Qty, Revenue only)
export async function exportPivotReport(storess, range, itemDataRevenue) {
  if (!range || !range?.tran_date) {
    console.error("exportPivotReport: missing or invalid `range`");
    return;
  }

  let keyword = "";
  try {
    keyword = (localStorage.getItem("lastSearchKeyword") || "").trim();
  } catch (e) {}

  const hasKeyword = keyword !== "";
  const lowerKeyword = keyword.toLowerCase();

  const masterList = await findObjectUseCase().execute("products");

  const filteredMasterList = masterList.filter((prod) => {
    if (!hasKeyword) return true;
    const desc = (prod.description || "").toLowerCase();
    return desc.includes(lowerKeyword);
  });

  const storesSet = new Set();
  const productsWithData = [];

  filteredMasterList.forEach((prod) => {
    const sku5 = String(prod.sku).padStart(5, "0");
    const revAgg = itemDataRevenue?.[sku5];
    if (revAgg?.stores) {
      Object.keys(revAgg.stores).forEach((storeCode) =>
        storesSet.add(storeCode),
      );
      productsWithData.push({
        sku: sku5,
        description: prod.description || sku5,
        unitPrice: prod.unitPrice || 0,
      });
    }
  });

  const allStores = Array.from(storesSet).sort();

  if (!productsWithData.length || !allStores.length) {
    console.warn("exportPivotReport: no data to export");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Pivot Report");

  // HEADER ROW 1
  const headerRow1 = worksheet.getRow(1);
  headerRow1.getCell(1).value = "Store";
  headerRow1.getCell(1).font = {
    bold: true,
    size: 11,
    color: { argb: "FFFFFFFF" },
  };
  headerRow1.getCell(1).fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF2E5090" },
  };
  headerRow1.getCell(1).alignment = {
    vertical: "middle",
    horizontal: "center",
  };

  productsWithData.forEach((prod, idx) => {
    const startCol = 2 + idx * 3; // 3 columns per product
    const mergeEndCol = startCol + 2;

    worksheet.mergeCells(1, startCol, 1, mergeEndCol);

    const cell = headerRow1.getCell(startCol);
    cell.value = `${prod.description} - (${prod.sku})`;
    cell.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: idx % 2 === 0 ? "FF4472C4" : "FF2E5090" },
    };
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };
  });

  headerRow1.height = 30;

  // HEADER ROW 2 (3 sub columns per product)
  const headerRow2 = worksheet.getRow(3);
  const subHeaders = ["Sold Quantity", "Unit Price", "Revenue"];

  productsWithData.forEach((_, idx) => {
    const startCol = 2 + idx * 3;
    subHeaders.forEach((label, subIdx) => {
      const cell = headerRow2.getCell(startCol + subIdx);
      cell.value = label;
      cell.font = { bold: true, size: 10, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF5B9BD5" },
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });
  });

  headerRow2.height = 20;

  // DATA ROWS
  allStores.forEach((storeCode, storeIdx) => {
    const rowNum = 4 + storeIdx;
    const row = worksheet.getRow(rowNum);

    row.getCell(1).value = storeCode;

    const SKU_MULTIPLIERS = {
      "00775": 10,
      "00777": 10,
      "00779": 10,
      "00791": 3,
      "00792": 20,
    };

    productsWithData.forEach((prod, idx) => {
      const startCol = 2 + idx * 3;
      const revAgg = itemDataRevenue?.[prod.sku];

      const storeData = revAgg?.stores?.[storeCode];

      const multiplier = SKU_MULTIPLIERS[revAgg?.sku] ?? 1;
      // const soldQty = storeData?.quantity * 10 || 0;
      const soldQty = (storeData?.quantity ?? 0) * multiplier;
      const revenue = toNumberr(storeData?.sales || 0);
      const unitPrice = toNumberr(revAgg.unitPrice || 0);

      const values = [soldQty, unitPrice, revenue];

      values.forEach((val, subIdx) => {
        const cell = row.getCell(startCol + subIdx);
        cell.value = val || "";
        cell.alignment = { vertical: "middle", horizontal: "right" };
        cell.numFmt = subIdx === 0 ? "#,##0" : "#,##0.00";
      });
    });
  });

  // TOTAL ROW
  const totalRowNum = 4 + allStores.length;
  const totalRow = worksheet.getRow(totalRowNum);
  totalRow.getCell(1).value = "TOTAL";
  totalRow.getCell(1).font = { bold: true };

  productsWithData.forEach((prod, idx) => {
    const startCol = 2 + idx * 3;

    subHeaders.forEach((_, subIdx) => {
      const cell = totalRow.getCell(startCol + subIdx);
      if (subIdx === 1) {
        cell.value = toNumberr(prod.unitPrice || 0);
        cell.font = { bold: true };
        cell.numFmt = "#,##0.00";
      } else {
        const colLetter = getExcelColumn(startCol + subIdx);
        cell.value = {
          formula: `SUM(${colLetter}4:${colLetter}${totalRowNum - 1})`,
        };
        cell.font = { bold: true };
        cell.numFmt = subIdx === 0 ? "#,##0" : "#,##0.00";
      }
    });
  });

  // COLUMN WIDTHS
  worksheet.getColumn(1).width = 30;
  productsWithData.forEach((_, idx) => {
    const startCol = 2 + idx * 3;
    worksheet.getColumn(startCol).width = 14;
    worksheet.getColumn(startCol + 1).width = 14;
    worksheet.getColumn(startCol + 2).width = 14;
  });

  worksheet.views = [{ state: "frozen", xSplit: 1, ySplit: 2 }];

  const dateRange = `${range.tran_date["$gte"].split("T")[0]}-${range.tran_date["$lte"].split("T")[0]}`;
  const fileName = `Store-Count${storess}-${dateRange}-report.xlsx`;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);

  console.log(`✅ Pivot report exported: ${fileName}`);
}

// Pivot Report 2: rows = dates, columns = products (Sold Qty, Total Sales), + Summary
export async function exportPivotReport2(storess, range, itemDataRevenue) {
  if (!range || !range?.tran_date) {
    console.error("exportPivotReport2: missing or invalid `range`");
    return;
  }

  // Load search keyword
  let keyword = "";
  try {
    keyword = (localStorage.getItem("lastSearchKeyword") || "").trim();
  } catch (e) {}
  const hasKeyword = keyword !== "";
  const lowerKeyword = keyword.toLowerCase();

  // Fetch master list and filter by keyword
  const masterList = await findObjectUseCase().execute("products");
  const filteredMasterList = masterList.filter((prod) => {
    if (!hasKeyword) return true;
    return (prod.description || "").toLowerCase().includes(lowerKeyword);
  });

  // Collect products that have data and all unique dates
  const productsWithData = [];
  const allDatesSet = new Set();

  filteredMasterList.forEach((prod) => {
    const sku5 = String(prod.sku).padStart(5, "0");
    const revAgg = itemDataRevenue?.[sku5];
    if (!revAgg?.stores) return;

    let hasAnyDate = false;
    Object.values(revAgg.stores).forEach((storeData) => {
      if (storeData?.dates) {
        Object.keys(storeData.dates).forEach((d) => {
          allDatesSet.add(d);
          hasAnyDate = true;
        });
      }
    });

    if (hasAnyDate) {
      productsWithData.push({
        sku: sku5,
        description: prod.description || sku5,
        unitPrice: toNumberr(revAgg.unitPrice || 0),
      });
    }
  });

  const allDates = Array.from(allDatesSet).sort();

  if (productsWithData.length === 0 || allDates.length === 0) {
    console.warn("exportPivotReport2: no data to export");
    return;
  }

  const SKU_MULTIPLIERS = {
    "00775": 10,
    "00777": 10,
    "00779": 10,
    "00791": 3,
    "00792": 20,
  };

  // Build a lookup: dateAgg[date][sku] = { quantity, sales }
  const dateAgg = {};
  allDates.forEach((d) => {
    dateAgg[d] = {};
  });

  productsWithData.forEach((prod) => {
    const revAgg = itemDataRevenue?.[prod.sku];
    if (!revAgg?.stores) return;

    const multiplier = SKU_MULTIPLIERS[prod.sku] ?? 1;

    Object.values(revAgg.stores).forEach((storeData) => {
      if (!storeData?.dates) return;
      Object.entries(storeData.dates).forEach(([dateStr, dateData]) => {
        if (!dateAgg[dateStr]) return;
        if (!dateAgg[dateStr][prod.sku]) {
          dateAgg[dateStr][prod.sku] = { quantity: 0, sales: 0 };
        }
        dateAgg[dateStr][prod.sku].quantity += (dateData.quantity || 0) * multiplier;
        dateAgg[dateStr][prod.sku].sales += toNumberr(dateData.sales || 0);
      });
    });
  });

  // Build Excel
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Date Pivot Report");

  const productCount = productsWithData.length;
  const gapCol = 2 + productCount * 3; // gap column after all products
  const summaryStartCol = gapCol + 1;

  // === ROW 1: Header with product names ===
  const headerRow1 = worksheet.getRow(1);

  // A1: "tran_date"
  const cellA1 = headerRow1.getCell(1);
  cellA1.value = "tran_date";
  cellA1.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
  cellA1.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF2E5090" },
  };
  cellA1.alignment = { vertical: "middle", horizontal: "center" };
  cellA1.border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };

  // Product headers (merged 3 cols each)
  productsWithData.forEach((prod, idx) => {
    const startCol = 2 + idx * 3;
    const endCol = startCol + 2;
    worksheet.mergeCells(1, startCol, 1, endCol);
    const cell = headerRow1.getCell(startCol);
    cell.value = `${prod.description} - (${prod.sku})`;
    cell.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: idx % 2 === 0 ? "FF4472C4" : "FF2E5090" },
    };
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Gap column
  headerRow1.getCell(gapCol).value = "";
  headerRow1.getCell(gapCol).fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFE0E0E0" },
  };

  // Summary header (merged 2 cols)
  worksheet.mergeCells(1, summaryStartCol, 1, summaryStartCol + 1);
  const summaryHeaderCell = headerRow1.getCell(summaryStartCol);
  summaryHeaderCell.value = "Summary";
  summaryHeaderCell.font = {
    bold: true,
    size: 11,
    color: { argb: "FFFFFFFF" },
  };
  summaryHeaderCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF70AD47" },
  };
  summaryHeaderCell.alignment = { vertical: "middle", horizontal: "center" };
  summaryHeaderCell.border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };
  headerRow1.height = 30;

  // === ROW 2: Sub-headers ===
  const headerRow2 = worksheet.getRow(2);
  headerRow2.getCell(1).value = "";
  headerRow2.getCell(1).fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF2E5090" },
  };
  headerRow2.getCell(1).border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };

  productsWithData.forEach((_, idx) => {
    const startCol = 2 + idx * 3;
    ["Sold Quantity", "Unit Price", "Total Sales"].forEach((label, subIdx) => {
      const cell = headerRow2.getCell(startCol + subIdx);
      cell.value = label;
      cell.font = { bold: true, size: 10, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF5B9BD5" },
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // Gap column row 2
  headerRow2.getCell(gapCol).value = "";
  headerRow2.getCell(gapCol).fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFE0E0E0" },
  };

  // Summary sub-headers
  ["Total Sold Quantity", "Total Revenue"].forEach((label, subIdx) => {
    const cell = headerRow2.getCell(summaryStartCol + subIdx);
    cell.value = label;
    cell.font = { bold: true, size: 10, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF70AD47" },
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });
  headerRow2.height = 20;

  // === DATA ROWS: one per date ===
  allDates.forEach((dateStr, dateIdx) => {
    const rowNum = 3 + dateIdx;
    const dataRow = worksheet.getRow(rowNum);
    const isEven = dateIdx % 2 === 0;
    const bgColor = isEven ? "FFFFFFFF" : "FFF2F2F2";

    // Date cell
    const dateCell = dataRow.getCell(1);
    dateCell.value = new Date(dateStr + "T10:00:00");
    dateCell.numFmt = "YYYY-MM-DD";
    dateCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: bgColor },
    };
    dateCell.alignment = { vertical: "middle", horizontal: "center" };
    dateCell.border = {
      top: { style: "thin", color: { argb: "FFD3D3D3" } },
      left: { style: "thin", color: { argb: "FFD3D3D3" } },
      bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
      right: { style: "thin", color: { argb: "FFD3D3D3" } },
    };

    let totalQtyForDate = 0;
    let totalSalesForDate = 0;

    // Product data
    productsWithData.forEach((prod, idx) => {
      const startCol = 2 + idx * 3;
      const prodData = dateAgg[dateStr]?.[prod.sku] || {
        quantity: 0,
        sales: 0,
      };

      totalQtyForDate += prodData.quantity;
      totalSalesForDate += prodData.sales;

      // Sold Quantity
      const qtyCell = dataRow.getCell(startCol);
      qtyCell.value = prodData.quantity || "";
      qtyCell.numFmt = "#,##0";
      qtyCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: bgColor },
      };
      qtyCell.alignment = { vertical: "middle", horizontal: "right" };
      qtyCell.border = {
        top: { style: "thin", color: { argb: "FFD3D3D3" } },
        left: { style: "thin", color: { argb: "FFD3D3D3" } },
        bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
        right: { style: "thin", color: { argb: "FFD3D3D3" } },
      };

      // Unit Price
      const unitPriceCell = dataRow.getCell(startCol + 1);
      unitPriceCell.value = prod.unitPrice || "";
      unitPriceCell.numFmt = "#,##0.00";
      unitPriceCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: bgColor },
      };
      unitPriceCell.alignment = { vertical: "middle", horizontal: "right" };
      unitPriceCell.border = {
        top: { style: "thin", color: { argb: "FFD3D3D3" } },
        left: { style: "thin", color: { argb: "FFD3D3D3" } },
        bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
        right: { style: "thin", color: { argb: "FFD3D3D3" } },
      };

      // Total Sales
      const salesCell = dataRow.getCell(startCol + 2);
      salesCell.value = prodData.sales || "";
      salesCell.numFmt = "#,##0.00";
      salesCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: bgColor },
      };
      salesCell.alignment = { vertical: "middle", horizontal: "right" };
      salesCell.border = {
        top: { style: "thin", color: { argb: "FFD3D3D3" } },
        left: { style: "thin", color: { argb: "FFD3D3D3" } },
        bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
        right: { style: "thin", color: { argb: "FFD3D3D3" } },
      };
    });

    // Gap column
    const gapCell = dataRow.getCell(gapCol);
    gapCell.value = "";
    gapCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE0E0E0" },
    };

    // Summary: Total Sold Quantity
    const summaryQtyCell = dataRow.getCell(summaryStartCol);
    summaryQtyCell.value = totalQtyForDate || "";
    summaryQtyCell.numFmt = "#,##0";
    summaryQtyCell.font = { bold: true };
    summaryQtyCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: bgColor },
    };
    summaryQtyCell.alignment = { vertical: "middle", horizontal: "right" };
    summaryQtyCell.border = {
      top: { style: "thin", color: { argb: "FFD3D3D3" } },
      left: { style: "thin", color: { argb: "FFD3D3D3" } },
      bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
      right: { style: "thin", color: { argb: "FFD3D3D3" } },
    };

    // Summary: Total Revenue
    const summaryRevCell = dataRow.getCell(summaryStartCol + 1);
    summaryRevCell.value = totalSalesForDate || "";
    summaryRevCell.numFmt = "#,##0.00";
    summaryRevCell.font = { bold: true };
    summaryRevCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: bgColor },
    };
    summaryRevCell.alignment = { vertical: "middle", horizontal: "right" };
    summaryRevCell.border = {
      top: { style: "thin", color: { argb: "FFD3D3D3" } },
      left: { style: "thin", color: { argb: "FFD3D3D3" } },
      bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
      right: { style: "thin", color: { argb: "FFD3D3D3" } },
    };

    dataRow.height = 18;
  });

  // === TOTALS ROW ===
  const totalRowNum = 3 + allDates.length;
  const totalRow = worksheet.getRow(totalRowNum);

  const totalCellA = totalRow.getCell(1);
  totalCellA.value = "TOTAL";
  totalCellA.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
  totalCellA.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF70AD47" },
  };
  totalCellA.alignment = { vertical: "middle", horizontal: "center" };
  totalCellA.border = {
    top: { style: "medium" },
    left: { style: "medium" },
    bottom: { style: "medium" },
    right: { style: "medium" },
  };

  // Product total formulas
  productsWithData.forEach((prod, idx) => {
    const startCol = 2 + idx * 3;
    [0, 1, 2].forEach((subIdx) => {
      const cell = totalRow.getCell(startCol + subIdx);
      if (subIdx === 1) {
        // Unit Price: static value, not a sum
        cell.value = prod.unitPrice || 0;
        cell.numFmt = "#,##0.00";
      } else {
        const colLetter = getExcelColumn(startCol + subIdx);
        cell.value = {
          formula: `SUM(${colLetter}3:${colLetter}${totalRowNum - 1})`,
        };
        cell.numFmt = subIdx === 0 ? "#,##0" : "#,##0.00";
      }
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF70AD47" },
      };
      cell.alignment = { vertical: "middle", horizontal: "right" };
      cell.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };
    });
  });

  // Gap column total row
  totalRow.getCell(gapCol).value = "";
  totalRow.getCell(gapCol).fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFE0E0E0" },
  };

  // Summary total formulas
  [0, 1].forEach((subIdx) => {
    const colLetter = getExcelColumn(summaryStartCol + subIdx);
    const cell = totalRow.getCell(summaryStartCol + subIdx);
    cell.value = {
      formula: `SUM(${colLetter}3:${colLetter}${totalRowNum - 1})`,
    };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF70AD47" },
    };
    cell.alignment = { vertical: "middle", horizontal: "right" };
    cell.border = {
      top: { style: "medium" },
      left: { style: "medium" },
      bottom: { style: "medium" },
      right: { style: "medium" },
    };
    cell.numFmt = subIdx === 1 ? "#,##0.00" : "#,##0";
  });
  totalRow.height = 22;

  // === COLUMN WIDTHS ===
  worksheet.getColumn(1).width = 14;
  productsWithData.forEach((_, idx) => {
    const startCol = 2 + idx * 3;
    worksheet.getColumn(startCol).width = 14;
    worksheet.getColumn(startCol + 1).width = 14;
    worksheet.getColumn(startCol + 2).width = 14;
  });
  worksheet.getColumn(gapCol).width = 3;
  worksheet.getColumn(summaryStartCol).width = 18;
  worksheet.getColumn(summaryStartCol + 1).width = 16;

  // Freeze header rows and date column
  worksheet.views = [{ state: "frozen", xSplit: 1, ySplit: 2 }];

  // === DOWNLOAD ===
  const dateRange = `${range.tran_date["$gte"].split("T")[0]}-${range.tran_date["$lte"].split("T")[0]}`;
  let fileName = `Date-Report${storess}-${dateRange}`;
  if (hasKeyword) {
    fileName += `-${keyword.replace(/[^a-z0-9]+/gi, "_")}`;
  }
  fileName += ".xlsx";

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);

  console.log(`✅ Date pivot report exported: ${fileName}`);
}

// Convert column number to Excel letter (1=A, 2=B, 27=AA, etc.)
function getExcelColumn(colNum) {
  let result = "";
  while (colNum > 0) {
    const remainder = (colNum - 1) % 26;
    result = String.fromCharCode(65 + remainder) + result;
    colNum = Math.floor((colNum - 1) / 26);
  }
  return result;
}

export function getChartDataBottomQuantity(itemDataQuantity) {
  // 1) Sort ascending by quantity, take bottom 30
  const sortedItems = Object.entries(itemDataQuantity || {})
    .sort((a, b) => a[1].quantity - b[1].quantity)
    .slice(0, 30);

  // 2) Extract labels and quantity values
  const labels = sortedItems.map(([, item]) => item.description);
  const quantityData = sortedItems.map(([, item]) => item.quantity);

  // 3) Build and return Highcharts options
  return {
    chart: {
      type: "bar",
    },
    title: {
      text: "Bottom 30 Items by Quantity",
    },
    xAxis: {
      categories: labels,
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: "10px",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Total Quantity",
        align: "high",
      },
      labels: {
        overflow: "justify",
      },
    },
    tooltip: {
      valueSuffix: " pcs",
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          format: "{point.y}",
        },
      },
    },
    series: [
      {
        name: "Quantity",
        data: quantityData,
        color: "#006096",
      },
    ],
  };
}
